import { Role } from '../helpers/role';
import { castIdRouteParams } from '../helpers/helpers';

export default [
    {
        path: '/annualcatalog/list',
        name: 'annualcatalog',
        component: () => import('../views/AnnualCatalog/List.vue'),
        meta: { claims: [{ name: 'annualCatalog', crud: 'read' }] }
    },
    {
        path: '/annualCatalog/details/:id',
        name: 'annualCatalogDetails',
        component: () => import('../views/AnnualCatalog/DetailsList.vue'),
        meta: { claims: [{ name: 'annualCatalog', crud: 'read' }] }
    },
/*    {
        path: '/annualcatalog/create',
        name: 'annnualCatalogCreate',
        component: () => import('../views/AnnualCatalog/AnnualCatalog.vue'),
        meta: { authorize: [Role.RegisterAdmin] }
    },*/
/*    {
        path: '/annualcatalog/createFromPlanning/:planningId',
        name: 'annualCatalogCreateFromPlanning',
        component: () => import('../views/AnnualCatalog/AnnualCatalog.vue'),
        meta: { authorize: [Role.RegisterAdmin] }
    },*/
    {
        path: '/annualcatalog/edit/:id',
        name: 'annnualCatalogEdit',
        component: () => import('../views/AnnualCatalog/AnnualCatalog.vue'),
        meta: { claims: [{ name: 'annualCatalog', crud: 'update' }] }
    },
    {
        path: '/annualCatalogProject/:id',
        name: 'annualCatalogProject',
        component: () => import('../views/annualCatalogProject/AnnualCatalogProject.vue'),
        meta: { claims: [{ name: 'annualCatalogProject', crud: 'create' }, { name: 'annualCatalogProject', crud: 'update' }] }
    },
    {
        path: '/annualCatalogProject/',
        name: 'annualCatalogProjectList',
        component: () => import('../views/annualCatalogProject/List.vue'),
        meta: { claims: [{ name: 'annualCatalogProject', crud: 'read' }] }
    }
]
